/* Preserve policy URLs as a no-JavaScript fallback and use current Shopify content. */
(() => {
  if (window.hssProductPolicyLinksReady) return;
  window.hssProductPolicyLinksReady = true;
  let returnDrawer = null;
  let switchingPolicy = false;
  document.body.addEventListener('modalClosed', () => {
    if (!returnDrawer || switchingPolicy) return;
    const drawer = returnDrawer;
    returnDrawer = null;
    requestAnimationFrame(() => drawer.open(document.getElementById('cart-icon-bubble')));
  });
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link) return;
    const currentModal = link.closest('.hss-policy-modal');
    const drawer = link.closest('cart-drawer');
    const product = link.closest('product-info') || ((currentModal || drawer) && document.querySelector('product-info'));
    if (!product || (!link.dataset.hssPolicy && !currentModal && !drawer)) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin) return;
    const key = link.dataset.hssPolicy || (
      url.pathname.endsWith('/policies/shipping-policy') ? 'shipping' :
      url.pathname.endsWith('/policies/refund-policy') ? 'refund' :
      url.pathname.endsWith('/pages/shipping-and-returns') ? 'details' : null
    );
    if (!key) return;
    const modal = document.getElementById(`HssPolicy-${key}-${product.dataset.section}`);
    if (!modal || typeof modal.show !== 'function') return;
    event.preventDefault();
    if (modal === currentModal) return;
    let opener = link;
    if (currentModal) {
      opener = currentModal.openedBy;
      switchingPolicy = true;
      currentModal.hide();
      switchingPolicy = false;
    }
    if (drawer) { returnDrawer = drawer; drawer.close(); }
    const firstHeading = modal.querySelector('.hss-policy-body')?.firstElementChild;
    const title = modal.querySelector('.hss-policy-header h2')?.textContent.trim().toLowerCase();
    if (firstHeading && /^H[12]$/.test(firstHeading.tagName) && firstHeading.textContent.trim().toLowerCase() === title) firstHeading.hidden = true;
    modal.show(opener);
  });
})();
